import { computed } from 'vue';
import { IInputStringEvent } from '@/models/input-events.interface';
import { ValidationProperties } from '@/models/validation.interface';
import { LoadingStatuses } from '@/models/loading.interface';
import validationPresenter from '@/presenters/validation-presenter';
import store from '@/store';

export default class NameCode {
	public name = computed((): string => {
		return store.getters.name();
	});

	public isLoading = computed((): boolean => {
		const loadingStatus = store.getters.loadingStatusPrimaryData();
		return loadingStatus === LoadingStatuses.ACTIVE;
	});

	public isFieldValidatedAndMissing = computed((): boolean => {
		return validationPresenter.isPropertyMissing(ValidationProperties.NAME);
	});

	public setNameBasedOnEvent(event: IInputStringEvent): void {
		const value = event?.target?.value;
		if (value === undefined) {
			return;
		}

		store.mutations.setName(value);

		if (!this.isFieldValidatedAndMissing.value) {
			return;
		}

		validationPresenter.validateMandatoryFields();
	}
}
